export const humanize = (string: string) => {
  if (!string) return ''
  return string
    .split(/_|-/)
    .map((s) => {
      return s.substr(0, 1).toUpperCase() + s.substr(1)
    })
    .join(' ')
}
